/**
 * Constants for the video package.
 */

// The states returned by the Youtube Player API.
// See player.getPlayerState() at
// https://developers.google.com/youtube/js_api_reference
export const VideoPlayerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    VIDEO_CUED: 5,
} as const;
